export const chatStatusOptions = [
	{ key: "abiertas", text: "Abiertas", value: "abiertas" },
	{ key: "cerradas", text: "Cerradas", value: "cerradas" },
];

export const stateOptions = [
	{ key: "a_tiempo", text: "A Tiempo", value: "A Tiempo" },
	{ key: "en_atraso", text: "En Atraso", value: "En Atraso" },
	{ key: "vencido", text: "Vencida", value: "Vencido" },
];

export const actionOptions = [
	{ key: "Bloquear", text: "Bloquear", value: "Bloquear" },
	{ key: "Cierre", text: "Cierre", value: "Cierre" },
	{ key: "Liberar", text: "Liberar", value: "Liberar" },
	{ key: "Tomar", text: "Tomar", value: "Tomar" },
	{ key: "Transferir", text: "Transferir", value: "Transferir" },
];

export const sectionOptions = [
	{ key: "Conversaciones", text: "Conversaciones", value: "Conversaciones" },
	{ key: "Generales", text: "Generales", value: "Generales" },
	{ key: "Tiempos", text: "Tiempos", value: "Tiempos" },
];

export const groupByOptions = [
	{ key: "grupo", text: "Grupo", value: "groupId" },
	{ key: "usuario", text: "Usuario", value: "userId" },
];
